import React from 'react';
import { bool, func, number, shape, string } from 'prop-types';
import CompensationSummaryCard from '../CompensationSummaryCard/CompensationSummaryCard';

class JobNotPricedCard extends React.Component {
  static propTypes = {
    checked: bool,
    onToggle: func,
    isConfigVisible: bool
  };

  render() {
    const { checked, onToggle, isConfigVisible } = this.props;

    return (
      <CompensationSummaryCard
        checked={checked}
        cardTitle="Job Not Priced"
        onToggle={onToggle}
        isConfigVisible={isConfigVisible}
        hasData={false}
      >
        <div className="comp-sum-card__not-priced">
          <div className="comp-sum-card__empty-title">This Job is Not Matched or Priced</div>
          <div className="pxl-text-small comp-sum-card__empty-body">
            When the job is matched or priced, market range, match details, <br />
            overall composite and survey job description will appear here
          </div>
        </div>
      </CompensationSummaryCard>
    );
  }
}

export default JobNotPricedCard;
